import styled from '@emotion/styled';

import { theme } from '@/theme';

export const StyledWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    color: ${theme.palette.components.icon};
`;

export const StyledDivider = styled('div')`
    height: 1rem;
`;

export const StyledMenuOption = styled('div')`
    padding-bottom: 1rem;
`;
